import type { FetchQuoteQuery } from '../../../graphql/types';

interface GetPetRegularOrderDailyAmountArgs {
  quote: FetchQuoteQuery['fetchQuote'] | null;
  petName: string;
}

interface GetPetRegularOrderDailyAmountReturn {
  regularOrderDailyAmount: number | null;
}

/** From a quote, get the regular order daily breakdown amount for a pet */
export function getPetRegularOrderDailyAmount({
  quote,
  petName,
}: GetPetRegularOrderDailyAmountArgs): GetPetRegularOrderDailyAmountReturn {
  if (!quote) {
    return {
      regularOrderDailyAmount: null,
    };
  }
  const petRegularOrderDailyAmount =
    quote.regularOrder.breakdown.daily.pets.find(
      item => item.name === petName
    )?.amount;

  if (!petRegularOrderDailyAmount) {
    return {
      regularOrderDailyAmount: null,
    };
  }

  return {
    regularOrderDailyAmount: petRegularOrderDailyAmount,
  };
}
